// Texty kampaňovej vrstvy — slovenské dvojča locale/cs/campaign.js.
import { NBSP } from '../../modules/money.js';

const pct = (n) => '−' + n + NBSP + '%';

export default {
  clearance: (claimPct) => (claimPct ? 'Výpredaj skladu až ' + pct(claimPct) : 'Výpredaj skladu'),
  clearancePrice: 'Výpredaj skladu',
  octSale: {
    name: 'Októbrový výpredaj',
    barStrong: 'OKTÓBROVÝ VÝPREDAJ',
    barLead: (claimPct) => (claimPct ? ' · výpredaj skladu až ' + pct(claimPct) : ' · práve prebieha'),
    barCta: 'Zobraziť výpredaj',
    zoneEyebrow: (claimPct) =>
      claimPct ? 'Výpredaj skladu až ' + pct(claimPct) + ' a ďalšie zľavy' : 'Zľavnený tovar naprieč sortimentom',
    zoneCta: 'Zobraziť celý výpredaj',
    bentoText: (claimPct) => (claimPct ? 'Výpredaj skladu až ' + pct(claimPct) + ' a ďalšie zľavy.' : 'Zľavnený tovar naprieč sortimentom.'),
    bentoCta: 'Zobraziť výpredaj',
    bandText: 'Zľavnené náradie, technika do dielne aj na záhradu a vybavenie domácnosti na jednom mieste.',
    tileBody: 'Tovar skladom za výpredajové ceny.',
    tileCta: 'Zobraziť výpredaj',
    clearanceBand: 'Výpredaj skladu je súčasťou Októbrového výpredaja.',
    clearanceBandLink: 'Všetky zľavnené produkty',
  },
  blackFriday: {
    name: 'Black Friday',
    barStrong: 'BLACK FRIDAY',
    barLead: (claimPct) => (claimPct ? ' · výpredaj skladu až ' + pct(claimPct) : ' · práve prebieha'),
    barCta: 'Zobraziť zľavy',
    zoneEyebrow: (claimPct) =>
      claimPct ? 'Výpredaj skladu až ' + pct(claimPct) + ' a ďalšie zľavy' : 'Zľavnený tovar naprieč sortimentom',
    zoneCta: 'Zobraziť celý Black Friday',
    bentoText: (claimPct) => (claimPct ? 'Výpredaj skladu až ' + pct(claimPct) + ' a ďalšie zľavy.' : 'Zľavnený tovar naprieč sortimentom.'),
    bentoCta: 'Zobraziť zľavy',
    bandText: 'Zľavnené náradie, technika do dielne aj na záhradu a vybavenie domácnosti na jednom mieste.',
    tileBody: 'Tovar skladom za výpredajové ceny.',
    tileCta: 'Zobraziť výpredaj',
    clearanceBand: 'Výpredaj skladu je súčasťou Black Friday.',
    clearanceBandLink: 'Všetky zľavnené produkty',
    priceTag: 'Black Friday cena',
    cartSaved: 'Black Friday: ušetrili ste ',
    buyBannerTitle: 'Black Friday',
    buyBannerText: (claimPct) =>
      claimPct ? 'Výpredaj skladu až ' + pct(claimPct) + ' a stovky ďalších zľavnených produktov.' : 'Stovky zľavnených produktov na jednom mieste.',
    buyBannerCta: 'Zobraziť zľavy',
    xmasTitle: (claimPct) => 'Vianoce až ' + pct(claimPct),
    xmasBody: 'Vianočný tovar skladom za výpredajové ceny.',
    xmasCta: 'Zobraziť Vianoce',
  },
};
